import React from "react";
import PropTypes from "prop-types";
import CampaignGroupPropType from "account-app/features/campaigns/campaign-group-prop-type";
import CampaignCard from "account-app/features/campaigns/campaign-results/campaign-card";
import CampaignStatusHeader from "account-app/features/campaigns/campaign-results/campaign-status-header";
import PerformanceSection from "account-app/features/campaigns/campaign-results/performance-section";
import ClientLandingHeader from "./client-landing-header";
import ClientLandingFaq from "./client-landing-faq";
import "./client-landing.styles.scss";
import "../account-app/account-app.styles.scss";
import "../account-app/layout/page.styles.scss";
import "../account-app/features/campaigns/campaign-results/campaign-results.styles.scss";

const propTypes = {
  campaignGroup: CampaignGroupPropType.isRequired,
  campaignResults: PropTypes.shape({
    campaignPackage: PropTypes.shape({
      packageLabel: PropTypes.string,
      packageDetails: PropTypes.string,
      startsAt: PropTypes.string,
      endsAt: PropTypes.string,
      newRenewalPlan: PropTypes.string,
      renewalDate: PropTypes.string
    }),
    destinationURL: PropTypes.string,
    targetingAreas: PropTypes.arrayOf(
      PropTypes.shape({ name: PropTypes.string, radius: PropTypes.number })
    ),
    vistarPostalCodes: PropTypes.arrayOf(
      PropTypes.shape({
        postalCode: PropTypes.string,
        count: PropTypes.number,
        category: PropTypes.string
      })
    ),
    uniqueContacts: PropTypes.number
  }).isRequired,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  campaignId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  clientToken: PropTypes.string.isRequired,
  presentingAgentName: PropTypes.string.isRequired,
  agentSignInPath: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  agentPhotoUrl: PropTypes.string,
  appName: PropTypes.string
};

const ClientLanding = ({
  campaignResults,
  campaignGroup,
  accountId,
  campaignId,
  clientToken,
  presentingAgentName,
  agentSignInPath,
  clientName,
  agentPhotoUrl = null,
  appName = "Adwerx"
}) => {
  return (
    <div className="account-app" data-testid="client-landing">
      <div className="page-content flex-grow-1" data-testid="page">
        <ClientLandingHeader
          presentingAgentName={presentingAgentName}
          agentPhotoUrl={agentPhotoUrl}
          agentSignInPath={agentSignInPath}
          clientName={clientName}
        />
        <CampaignStatusHeader campaignGroup={campaignGroup} />
        <ClientLandingFaq appName={appName} />
        <CampaignCard
          campaignGroup={campaignGroup}
          creativeTemplates={[]}
          campaignPackage={campaignResults.campaignPackage}
          destinationURL={campaignResults.destinationURL}
          targetingAreas={campaignResults.targetingAreas}
          vistarPostalCodes={campaignResults.vistarPostalCodes}
          uniqueContacts={campaignResults.uniqueContacts}
          clientView
        />
        <PerformanceSection
          accountId={accountId}
          campaignId={campaignId}
          clientToken={clientToken}
        />
      </div>
    </div>
  );
};

ClientLanding.propTypes = propTypes;

export default ClientLanding;
